import { useEffect, useState } from "react";
import { Route, Routes, useLocation, Navigate } from "react-router-dom";
import "bootstrap/dist/css/bootstrap.min.css";
import "./styles.css";

import Anasayfa from "./pages/Anasayfa";
import TumHesaplar from "./pages/TumHesaplar";
import Hakkimizda from "./pages/Hakkimizda";
import SikcaSorulanSorular from "./pages/SikcaSorulanSorular";
import Iletisim from "./pages/Iletisim";
import GizlilikIlkeleri from "./pages/GizlilikIlkeleri";
import NotFound from "./pages/NotFound";
import AracDegerKaybiHesaplama from "./pages/calculations/AracDegerKaybiHesaplama";
import AskerlikBorclanmasiHesaplama from "./pages/calculations/AskerlikBorclanmasiHesaplama";
import BilirkisiAsgariTarifeleri from "./pages/calculations/BilirkisiAsgariTarifeleri";
import FazlaCalismaHesaplama from "./pages/calculations/FazlaCalismaHesaplama";
import IcraMasrafiHesaplama from "./pages/calculations/IcraMasrafiHesaplama";
import IslahHarciHesaplama from "./pages/calculations/IslahHarciHesaplama";
import IhbarTazminatiHesaplama from "./pages/calculations/IhbarTazminatiHesaplama";
import IsGunuHesaplama from "./pages/calculations/IsGunuHesaplama";
import YillikIzinSuresiHesaplama from "./pages/calculations/YillikIzinSuresiHesaplama";
import TapuHarciHesaplama from "./pages/calculations/TapuHarciHesaplama";
import TahliyeTaahhutnamesiHesaplama from "./pages/calculations/TahliyeTaahhutnamesiHesaplama";
import KidemTazminatiHesaplama from "./pages/calculations/KidemTazminatiHesaplama";
import VekaletUcretiHesaplama from "./pages/calculations/VekaletUcretiHesaplama";
import MahkemeHarcGiderHesaplama from "./pages/calculations/MahkemeHarcGiderHesaplama";

import AdminLogin from "./pages/admin/AdminLogin";
import AdminIndex from "./pages/admin/AdminIndex";
import AdminAllBlogs from "./pages/admin/AdminAllBlogs";
import AdminBlogEditPage from "./pages/admin/AdminBlogEditPage";
import Blog from "./pages/blog/Blog";
import ListBlogs from "./pages/blog/ListBlogs";
import UyeOl from "./pages/UyeOl";
import GirisYap from "./pages/GirisYap";
import Contract from "./pages/contract/Contract";
import ListContracts from "./pages/contract/ListContracts";
import InspectContract from "./pages/contract/InspectContract";
import Payment from "./pages/Payment";

function ScrollToTop() {
    const { pathname } = useLocation();

    useEffect(() => {
        window.scrollTo(0, 0);
    }, [pathname]);

    return null;
}

const AdminRoute = ({ children }) => {
    const token = localStorage.getItem("admin_token");

    if (!token) {
        return <Navigate to="/" />;
    }

    return <AuthVerify token={token}>{children}</AuthVerify>;
};

const AuthVerify = ({ token, children }) => {
    const [isVerified, setIsVerified] = useState(null);

    useEffect(() => {
        const verifyToken = async () => {
            try {
                const response = await fetch(`${process.env.REACT_APP_API_URL}/admin/auth/verify`, {
                    method: "POST",
                    headers: {
                        "Content-Type": "application/json",
                        Authorization: `Bearer ${token}`,
                    },
                });

                setIsVerified(response.ok);
            } catch (error) {
                setIsVerified(false);
            }
        };

        verifyToken();
    }, [token]);

    if (isVerified === null) {
        return <div>Loading...</div>; // You can show a loader while checking authentication
    }

    return isVerified ? children : <Navigate to="/" />;
};

function VirtualPageViewPush() {
    const location = useLocation();

    useEffect(() => {
        const currentURL = window.location.origin + window.location.pathname;
        const previousReferrer = localStorage.getItem("referrer") || document.referrer || "Bilinmeyen";

        localStorage.setItem("referrer", currentURL);

        window.dataLayer.push({ ecommerce: null });
        window.dataLayer.push({
            event: "virtualPageView",
            pageUrl: currentURL,
            page_referrer: previousReferrer,
        });
    }, [location.pathname, location.search]);

    return null;
}

function App() {
    return (
        <div id="App">
            <ScrollToTop />
            <VirtualPageViewPush />
            <Routes>
                <Route index element={<Anasayfa />} />
                <Route path="hakkimizda" element={<Hakkimizda />} />
                <Route path="sikca-sorulan-sorular" element={<SikcaSorulanSorular />} />
                <Route path="iletisim" element={<Iletisim />} />
                <Route path="gizlilik-ilkeleri" element={<GizlilikIlkeleri />} />
                {/*
                <Route path="uye-ol" element={<UyeOl />} />
                <Route path="giris" element={<GirisYap />} />
                <Route path="odeme-yap" element={<Payment />} />
                <Route path="sozlesmeler">
                    <Route index element={<ListContracts />} />
                    <Route path="doldur/:contractSlug" element={<Contract />} />
                    <Route path=":contractSlug" element={<InspectContract />} />
                </Route>
                */}
                <Route path="hesaplamalar">
                    <Route index element={<TumHesaplar />} />
                    <Route
                        path="arac-deger-kaybi-hesaplama"
                        element={<AracDegerKaybiHesaplama />}
                    />
                    <Route
                        path="askerlik-borclanmasi-hesaplama"
                        element={<AskerlikBorclanmasiHesaplama />}
                    />
                    <Route
                        path="bilirkisi-asgari-tarifeleri"
                        element={<BilirkisiAsgariTarifeleri />}
                    />
                    <Route
                        path="fazla-calisma-hesaplama"
                        element={<FazlaCalismaHesaplama />}
                    />
                    <Route
                        path="icra-masrafi-hesaplama"
                        element={<IcraMasrafiHesaplama />}
                    />
                    <Route
                        path="islah-harci-hesaplama"
                        element={<IslahHarciHesaplama />}
                    />
                    <Route
                        path="ihbar-tazminati-hesaplama"
                        element={<IhbarTazminatiHesaplama />}
                    />
                    <Route path="is-gunu-hesaplama" element={<IsGunuHesaplama />} />
                    <Route
                        path="yillik-izin-suresi-hesaplama"
                        element={<YillikIzinSuresiHesaplama />}
                    />
                    <Route path="tapu-harci-hesaplama" element={<TapuHarciHesaplama />} />
                    <Route
                        path="tahliye-taahhutnamesine-dayali-icra-hesaplama"
                        element={<TahliyeTaahhutnamesiHesaplama />}
                    />
                    <Route
                        path="kidem-tazminati-hesaplama"
                        element={<KidemTazminatiHesaplama />}
                    />
                    <Route
                        path="vekalet-ucreti-hesaplama"
                        element={<VekaletUcretiHesaplama />}
                    />
                    <Route
                        path="mahkeme-harc-ve-gider-hesaplama"
                        element={<MahkemeHarcGiderHesaplama />}
                    />
                </Route>
                <Route path="admin/login" element={<AdminLogin />} />
                <Route
                    path="admin/index"
                    element={
                        <AdminRoute>
                            <AdminIndex />
                        </AdminRoute>
                    }
                />
                <Route
                    path="admin/all-blogs"
                    element={
                        <AdminRoute>
                            <AdminAllBlogs />
                        </AdminRoute>
                    }
                />
                <Route
                    path="/admin/blog/:id"
                    element={
                        <AdminRoute>
                            <AdminBlogEditPage />
                        </AdminRoute>
                    }
                />
                <Route path="/blog" element={<ListBlogs />} />
                <Route path="/blog/:blogSlug" element={<Blog />} />
                <Route path="*" element={<NotFound />} />
            </Routes>
        </div>
    );
}

export default App;
